var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"details_main"},[_c('d-header',{attrs:{"details":_vm.cerObj}}),_c('d-banner',{attrs:{"details":_vm.cerObj}}),_c('d-work',{attrs:{"details":_vm.cerObj}}),_c('d-work-course',{attrs:{"details":_vm.cerObj}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }